<script setup lang="ts">
import AppLayout from '@/components/AppLayout.vue'
import UpgradePlaceholder from '@/components/UpgradePlaceholder.vue'
import { useAuthStore } from '@/stores/auth'
import type { CapabilityName } from '@/api/me'
import { useGlobalModalEscape } from '@/composables/useModalEscape'

const auth = useAuthStore()

// 全局 Esc 关闭最上层弹窗(统一行为)
useGlobalModalEscape()
</script>

<template>
  <AppLayout>
    <RouterView v-slot="{ Component, route }">
      <!-- A1:路由声明了 capability 但租户未开通 → 升级引导,不渲染视图打 API 吃 403 红条 -->
      <UpgradePlaceholder
        v-if="route.meta.capability && !auth.hasCapability(route.meta.capability as CapabilityName)"
        :title="(route.meta.title as string) ?? '此功能'"
        :capability="route.meta.capability as CapabilityName"
      />
      <component :is="Component" v-else class="route-view" />
    </RouterView>
  </AppLayout>
</template>

<style scoped>
.route-view {
  flex: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
</style>
